var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-model",class:[`weight-${_vm.weight}`, `size-${_vm.size}`, `color-${_vm.color}`, _vm.uppercase ? 'uppercase' : '', _vm.block ? 'block' : '', _vm.ellipsis ? 'ellipsis' : '', `align-${_vm.align}`, _vm.striked ? 'striked' : '', `white-space-${_vm.whiteSpace}`]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }